import React from "react";

import img1 from "../../Assets/MainSlider/1.jpg";
import img2 from "../../Assets/MainSlider/2.jpg";
import img3 from "../../Assets/MainSlider/3.jpg";

export default function Advertisment() {
  return (
    <>
      <div
        id="carouselExampleAutoplaying"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={img1} className="d-block w-100" alt="advertisment1" />
          </div>
          <div className="carousel-item">
            <img src={img2} className="d-block w-100" alt="advertisment2" />
          </div>
          <div className="carousel-item">
            <img src={img3} className="d-block w-100" alt="advertisment3" />
          </div>
        </div>
      </div>
    </>
  );
}
